import {
	AssignStatus,
	InclusionFilterStatus,
	PriorityFilterStatus,
	SignalFilterStatus,
} from "@/enum/list.enum";

/**
 * URL-driven filter state readers for the list table (extracted from `UnassignedTable` to keep
 * that component shrinking). Each takes `location.search` so the component owns no parsing.
 */
export const getSearchTermFromUrl = (search: string): string =>
	new URLSearchParams(search).get("searchTerm") || "";

export const getInclusionStatusFromUrl = (
	search: string,
	assignStatus?: AssignStatus
): InclusionFilterStatus[] => {
	const params = new URLSearchParams(search);

	return params.get("inclusionStatus")
		? (JSON.parse(params.get("inclusionStatus") || "[]") as InclusionFilterStatus[])
		: assignStatus === AssignStatus.ARCHIVED
			? [InclusionFilterStatus.ADDED, InclusionFilterStatus.UNSURE, InclusionFilterStatus.NOT_FOUND]
			: [InclusionFilterStatus.ADDED];
};

/** Encoded "STATUS:filterParam" reason sub-filters of the grouped Show dropdown (PREC-3536). */
export const getExclusionReasonsFromUrl = (search: string): string[] => {
	const params = new URLSearchParams(search);

	return params.get("exclusionReasons")
		? (JSON.parse(params.get("exclusionReasons") || "[]") as string[])
		: [];
};

export const getPriorityFilterStatusFromUrl = (search: string): PriorityFilterStatus[] => {
	const params = new URLSearchParams(search);

	return params.get("priorityFilterStatus")
		? (JSON.parse(params.get("priorityFilterStatus") || "[]") as PriorityFilterStatus[])
		: [PriorityFilterStatus.ALL];
};

export const getSignalFilterStatusFromUrl = (search: string): SignalFilterStatus[] => {
	const params = new URLSearchParams(search);

	return params.get("signalFilterStatus")
		? (JSON.parse(params.get("signalFilterStatus") || "[]") as SignalFilterStatus[])
		: [SignalFilterStatus.ALL];
};
